<template>
  <BaseDialog
    :title="isEdit ? 'Редактировать' : 'Добавить'"
    :dialog="dialog"
    :is-show-mode="isShowMode"
    :is-edit="isEdit"
    :is-invalid="$v.$invalid"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="save"
  >
    <UITextField
      v-model="action.name"
      label="Название" placeholder="Добавьте название" class="mt-2"
      :disabled="isShowMode"
      :error-messages="errorMessages.name"
      @input="$v.action.name.$touch()"
    />

    <UITextField
      v-if="action.isPair"
      v-model="action.inOrder"
      type="number" label="Порядок" placeholder="Добавьте порядок" class="mt-2"
      :disabled="isShowMode"
      :error-messages="errorMessages.inOrder"
      @input="$v.action.inOrder.$touch()"
    />

    <v-checkbox
      v-model="action.isPair"
      label="Парное" class="mt-2 base-check-box"
      hide-details
      :disabled="isShowMode"
      :error-messages="errorMessages.isPair"
      @input="$v.action.isPair.$touch()"
    />

    <v-checkbox
      v-model="action.istimefix"
      label="Фиксирует время" class="mt-2 base-check-box"
      hide-details
      :disabled="isShowMode"
      :error-messages="errorMessages.istimefix"
      @input="$v.action.istimefix.$touch()"
    />
  </BaseDialog>
</template>

<script>
import { Action } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import {
  maxLength,
  required, requiredIf,
} from 'vuelidate/lib/validators'
import UITextField from '@/ui/input/UITextField'
import BaseDialog from '@/ui/dialog/BaseDialog'

export default {
  components: {
    UITextField,
    BaseDialog,
  },

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  data: () => ({ action: new Action() }),

  validations() {
    return {
      action: {
        name: { required, maxLength: maxLength(200) },
        inOrder: { required: requiredIf((el) => Boolean(el.isPair)) },
      },
    }
  },

  computed: {
    isEdit() {
      return !!this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.action.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v.action[key])
      })

      return allErrors
    },
  },

  methods: {
    save() {
      this.$emit('save', this.action.getForAPI())
    },

    resetModal() {
      this.$v.$reset()
      this.action = new Action()
    },

    closeModal() {
      this.action = new Action()
      this.$emit('closeModal')
    },
  },

  watch: {
    selectedItem(val) {
      this.action = new Action(val)
    },

    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
